import client from '../../../apis/portaliref';
import helper from 'helpers/steinerHelper';

const apis = helper.createApi('indicatori', client, {
    per_page: 'perPage',
    page: 'page',
    ricerca: 'q',
    orderby: 'orderKey',
    orderdir: 'orderDirection',
});

apis.fetchObbiettiviAnnualiComune = () => {
    return client({
        url: `obbiettiviAnnualiComune`,
        method: 'get',
    });
};

apis.aggiornaObbiettiviAnnualiComune = (comuni) => {
    return client({
        url: `obbiettiviAnnualiComune`,
        method: 'patch',
        data: comuni,
    });
};

apis.fetchObbiettivoMailUniche = () => {
    return client({
        url: `obbiettivoMailUniche`,
        method: 'get',
    });
};

apis.aggiornaObbiettivoMailUniche = (percentuale_crm, percentuale_no_crm) => {
    return client({
        url: `obbiettivoMailUniche`,
        method: 'patch',
        data: percentuale_crm,
        percentuale_no_crm,
    });
};

export default apis;

// ho una chiamata API che mi restituisce un array chiamato 'comuni'.
// Questo array contiene al suo interno una moltitudine di oggetti.
// Ciascuno di questi oggetti è così strutturato:
// oggetto1 = {
//     id: '072d1bba-0b18-4daa-ae76-61e241a029a3',
//     comune: 'Roseto degli Abruzzi',
//     regione: 'Abruzzo',
//     cpa: 3.5,
//     obbiettivi_mensili: {
//         gennaio: 2,
//         febbraio: 3,
//         marzo: 1,
//         aprile: 2,
//         maggio: 4,
//         giugno: 1,
//         luglio: 2,
//         agosto: 25,
//         settembre: 0,
//         ottobre: 0,
//         novembre: 0,
//         dicembre: 0
//     }
// };

// per la patch l'array deve tornare alla forma originale...
// array 'obbiettiviComune': [[...], [...], [...], ...]
// ogni array = [1337, "rimini", "emilia-romagna", 3.5, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]

// array 'comuni':[{...},{...},{...},...]
// oggetto1 = {id:1337, comune: "rimini", regione: "emilia-romagna", cpa: 3.5, obbiettivi_mensili: {gennaio: 1, febbraio: 2, marzo: 3, aprile: 4, maggio: 5, giugno: 6, luglio: 7, agosto: 8, settembre: 9, ottobre: 10, novembre: 11, dicembre: 12}}
